export function activatePromoCode(code, callback) {
    const formData = new FormData();
    formData.append('promoCode', code);

    fetch('/rest/promo/code/activate', {
        method: 'POST',
        body: formData,
    })
        .then(res => res.json())
        .then(
            (result) => {
                callback(result);
            }
        )
}
